import { APP_VERSION } from "../runtime/Environment";

// Single source for the current app's identity — its name and build version.
// Each app entry calls `setAppName` at startup; request headers, tracking, and
// error tracking read it back. The name can change after boot (e.g. a shell
// composing several apps per route), so consumers must resolve it at use time,
// never snapshot it at init.

// Default that makes a missing `setAppName` call visible in tracking/API logs.
export const DEFAULT_APP_NAME = "web_unknown";

let appName: string = DEFAULT_APP_NAME;

export function setAppName(name: string): void {
	appName = name;
}

export function getAppName(): string {
	return appName;
}

// The build version (`VITE_PACKAGE_VERSION`); "-1" when the build doesn't define it.
export function getAppVersion(): string {
	return APP_VERSION ?? "-1";
}

// Value for the `wev-app-version` request header, e.g. "web_freya/18.6.0".
export function getAppVersionHeader(): string {
	return `${getAppName()}/${getAppVersion()}`;
}
